import { z } from 'zod';

export const MAX_MANUAL_TITLE_OWNERS = 4;
export const TITLE_SEARCH_MANUAL_FALLBACK_TIMEOUT_MS = 5 * 60 * 1000;

const ownerName = z
  .string()
  .trim()
  .min(1, 'Enter a name')
  .max(100, 'Use at most 100 characters')
  .transform(value => value.replace(/\s+/g, ' '));

export const saveManualTitleOwnersSchema = z
  .object({
    applicationId: z.string().min(1),
    declarationAccepted: z.literal(true),
    owners: z
      .array(
        z
          .object({
            id: z.string().min(1).optional(),
            firstName: ownerName,
            lastName: ownerName,
          })
          .strict(),
      )
      .min(1)
      .max(MAX_MANUAL_TITLE_OWNERS),
  })
  .strict()
  .superRefine(({ owners }, context) => {
    const names = owners.map(owner => `${owner.firstName} ${owner.lastName}`.toLowerCase());
    const ids = owners.flatMap(owner => (owner.id ? [owner.id] : []));
    if (new Set(names).size !== names.length || new Set(ids).size !== ids.length) {
      context.addIssue({ code: z.ZodIssueCode.custom, path: ['owners'], message: 'Enter each owner only once' });
    }
  });
